import { AmsLogStatus } from '~/api/graphql';

// The decision and write deadlines together allow five minutes after sending.
export const AMS_LOG_POLL_WINDOW_MS = 5 * 60_000;

export const amsLogPollingRemainingMs = (
  status: AmsLogStatus | null | undefined,
  sentAt: Date | string | null | undefined,
  nowMs: number
) => {
  if (status !== AmsLogStatus.Logging || !sentAt) return 0;
  const sentAtMs = new Date(sentAt).getTime();
  return Number.isFinite(sentAtMs) ? Math.max(0, sentAtMs + AMS_LOG_POLL_WINDOW_MS - nowMs) : 0;
};
